import { Link } from "react-router";

import { usePublicDocumentTitle } from "@/hooks";
import { useT } from "@/i18n";

export function NotFoundPage() {
  const { t } = useT();
  // The app name alone, rather than whichever page title the previous route left.
  usePublicDocumentTitle(null);
  return (
    <div className="bg-bg flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="font-display text-fg text-6xl font-bold">404</h1>
      <p className="text-fg mt-4 text-lg">{t("notFound.title")}</p>
      <p className="text-fg-muted mt-2 text-sm">{t("notFound.description")}</p>
      <Link
        to="/ask"
        className="bg-accent text-accent-fg hover:bg-accent-hover mt-8 rounded-md px-6 py-2 text-sm font-medium"
      >
        {t("notFound.action")}
      </Link>
    </div>
  );
}
